
//limite de paginación en la lista de ofertas
export const OFFERS_LIMIT_PAGES = 20;

//Titulos de pagina no dinámicos
export const OFFERS_LIST_TITLE = 'Bolsa de trabajo';
export const OFFERS_LIST_TITLE_PAGE = `${OFFERS_LIST_TITLE} | ILERNA`;
export const EDIT_OFFER_TITLE = 'Publicar oferta';
export const EDIT_OFFER_TITLE_PAGE = `${EDIT_OFFER_TITLE} | ILERNA`;
export const USER_DATA_TITLE = 'Datos de usuario';
export const USER_DATA_TITLE_PAGE = `${USER_DATA_TITLE} | ILERNA`;
export const USER_CHANGE_MAIL_TITLE = 'Cambiar correo electrónico';
export const USER_CHANGE_MAIL_TITLE_PAGE = `${USER_CHANGE_MAIL_TITLE} | ILERNA`;
export const USER_CHANGE_PASSWORD_TITLE = 'Cambiar contraseña';
export const USER_CHANGE_PASSWORD_TITLE_PAGE = `${USER_CHANGE_PASSWORD_TITLE} | ILERNA`;
export const USER_CHANGE_DATA_TITLE = 'Cambiar datos de contacto';
export const USER_CHANGE_DATA_TITLE_PAGE = `${USER_CHANGE_DATA_TITLE} | ILERNA`;
export const COMPANY_DATA_TITLE = 'Perfil de empresa';
export const COMPANY_DATA_TITLE_PAGE = `${COMPANY_DATA_TITLE} | ILERNA`;
export const NEW_COMPANY_TITLE_PAGE = `Registro | ILERNA`;




